// Light / dark theme controller.
// Persists user's choice in localStorage and toggles the `light` class on
// the root <html> element. All light-mode overrides in index.css scope
// themselves to `html.light`, so the default (no class) stays dark.
//
// Exposes `useCurrentTheme()` for consumers (e.g. Toaster) that need
// their own theme-dependent props to re-render when the user flips it.

import { useSyncExternalStore } from "react";

const KEY = "cold_theme";
const listeners = new Set();

export function getStoredTheme() {
  try {
    return localStorage.getItem(KEY) || "dark";
  } catch (_e) {
    return "dark";
  }
}

export function applyTheme(theme) {
  const html = document.documentElement;
  if (theme === "light") {
    html.classList.add("light");
    html.setAttribute("data-theme", "light");
  } else {
    html.classList.remove("light");
    html.setAttribute("data-theme", "dark");
  }
}

export function setTheme(theme) {
  try {
    localStorage.setItem(KEY, theme);
  } catch (_e) { /* noop */ }
  applyTheme(theme);
  listeners.forEach((cb) => cb());
}

export function initTheme() {
  applyTheme(getStoredTheme());
}

function subscribe(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function useCurrentTheme() {
  return useSyncExternalStore(subscribe, getStoredTheme, () => "dark");
}
